<template>
	<!-- 
		Actualización del aviso de cookies, incluye transición de estado, 
		timeout de visibilidad del aviso y almacenamiento en localStorage con clave configurable por sitio.

		@author Daniel Lepe
		@version 1.1
		@date Nov 4th, 2026
	-->
	<transition name="cookie-notice">
		<div v-if="isVisible" class="cookie-notice">

			<div class="cookie-notice__content">

				<div class="cookie-notice__text">

					<h3>
						This website does not use cookies
					</h3>

					<p>
						We do not use tracking cookies, advertising cookies or cross-site
						profiling technologies. Learn more about our cookie-free approach.
					</p>

				</div>

				<div class="cookie-notice__actions">

					<router-link
						to="/cookies"
						class="cookie-notice__link"
					>
						Learn More
					</router-link>

					<button
						type="button"
						class="cookie-notice__button"
						@click="closeNotice"
					>
						OK
					</button>

				</div>

			</div>

		</div>
	</transition>

</template>

<script>
export default {
	name: 'CookieNotice',

	props: {
		cookieNoticeKey: {
			type: String,
			default: 'cookieNoticeClosedFBCCPV1'
		},
		timeout: {
			type: Number,
			default: 3000
		}
	},

	data() {
		return {
			isVisible: false
		};
	},

	mounted() {
		setTimeout(async () => {
			const cookieNoticeClosed = window.localStorage.getItem(this.cookieNoticeKey);
			this.isVisible = !cookieNoticeClosed;
		}, this.timeout);
	},

	methods: {

		closeNotice() {
			this.isVisible = false;
			window.localStorage.setItem(this.cookieNoticeKey, true);
		}

	}
};
</script>

<style lang="scss" scoped>
.cookie-notice {
	position: fixed;

	left: 16px;
	right: 16px;
	bottom: 16px;

	z-index: 9999;

	padding: 20px;

	background: rgba(17, 24, 39, .98);

	border: 1px solid rgba(255, 255, 255, .12);
	border-radius: 16px;

	box-shadow: 0 18px 50px rgba(0, 0, 0, .35);

	backdrop-filter: blur(14px);
	-webkit-backdrop-filter: blur(14px);

	&__content {
		display: flex;
		flex-direction: column;

		gap: 20px;

		max-width: 1280px;

		margin: 0 auto;
	}

	&__text {

		h3 {
			margin: 0 0 8px;

			color: var(--white);

			font-size: 18px;
			line-height: 1.3;
		}

		p {
			margin: 0;

			color: var(--text-muted);

			font-size: 14px;
			line-height: 1.6;
		}
	}

	&__actions {
		display: flex;
		flex-direction: column;

		gap: 10px;
	}

	&__link,
	&__button {
		display: inline-flex;
		align-items: center;
		justify-content: center;

		min-height: 44px;

		padding: 0 20px;

		border-radius: 10px;

		font-size: 13px;
		font-weight: 700;
		letter-spacing: .5px;

		text-transform: uppercase;

		transition: var(--transition);

		cursor: pointer;
	}

	&__link {
		color: var(--white);

		border: 1px solid rgba(255, 255, 255, .25);

		text-decoration: none;

		&:hover {
			border-color: var(--primary);
			color: var(--primary);
		}
	}

	&__button {
		border: 1px solid var(--primary);

		background: var(--primary);
		color: var(--white);

		&:hover {
			background: var(--primary-hover);
			border-color: var(--primary-hover);
		}
	}
}

.cookie-notice-enter-active {
	animation: fadeUp .6s ease both;
}

.cookie-notice-leave-active {
	animation: fadeDown .3s ease both;
}

@keyframes fadeUp {
	from {
		opacity: 0;
		transform: translateY(16px);
	}

	to {
		opacity: 1;
		transform: translateY(0);
	}
}

@keyframes fadeDown {
	from {
		opacity: 1;
		transform: translateY(0);
	}

	to {
		opacity: 0;
		transform: translateY(16px);
	}
}
@media (min-width: 768px) {
	.cookie-notice {
		left: 24px;
		right: 24px;
		bottom: 24px;

		padding: 22px 26px;

		&__content {
			flex-direction: row;
			align-items: center;
			justify-content: space-between;

			gap: 30px;
		}

		&__text {
			max-width: 760px;
		}

		&__actions {
			flex-direction: row;
			flex-shrink: 0;
		}
	}
}
</style>